import { DicomStructureSet } from '~/domain/dicom/dicomstructureset';

export interface QaCoverage {
    // Only on the target scan's segmentation: nothing to deform onto it.
    readonly onlyTarget: readonly string[];
    // Only on the planning scan's segmentation: nothing to measure it against.
    readonly onlyPlanning: readonly string[];
    // On both, yet the measurement returned nothing for them.
    readonly notMeasured: readonly string[];
}

const holds = (names: readonly string[], name: string) =>
    names.some((held) =>
        DicomStructureSet.structureNamesTrimmedEqual(held, name)
    );

export function qaCoverage(
    targetNames: readonly string[],
    planningNames: readonly string[],
    measuredNames: readonly string[]
): QaCoverage {
    return {
        onlyTarget: targetNames.filter((name) => !holds(planningNames, name)),
        onlyPlanning: planningNames.filter((name) => !holds(targetNames, name)),
        notMeasured: targetNames.filter(
            (name) => holds(planningNames, name) && !holds(measuredNames, name)
        ),
    };
}
